import withValues from "../hocs/withValues";
import AutoInput from "../containers/AutoInput";
import React, { Component } from "react";
import { Form, Tabs } from "antd";

const TabPane = Tabs.TabPane;

class InstructionLetterCreate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      customer: null,
      customerQuery: null,
      servicetype: null,
      servicetypeQuery: null
    };
  }

  getCustomerFilter() {
    let customerFilter = {
      or: [
        {
          id: this.state.customer
        }
      ]
    };

    if (this.state.customerQuery) {
      customerFilter.or = [
        ...customerFilter.or,
        {
          active: true,
          name: {
            contains: this.state.customerQuery
          }
        }
      ];
    }

    return customerFilter;
  }
  getServiceTypeFilter() {
    let servicetypeFilter = {
      or: [
        {
          id: this.state.servicetype
        }
      ]
    };

    if (this.state.servicetypeQuery) {
      servicetypeFilter.or = [
        ...servicetypeFilter.or,
        {
          active: true,
          name: {
            contains: this.state.servicetypeQuery
          }
        }
      ];
    }

    return servicetypeFilter;
  }

  render() {
    const customer = this.getCustomerFilter();

    return (
      <div style={{ marginTop: -25 }}>
        <Tabs defaultActiveKey="letter">
          <TabPane tab="Carta de Instrucciones" key="letter">
            <Form>
              <AutoInput
                form={this.props.form}
                model={"instructionletter"}
                attribute={"customerId"}
                ajax
                onSearch={value => {
                  this.setState({ customerQuery: value, active: true });
                }}
                onChange={value => {
                  const { id } = JSON.parse(value);
                  this.setState({ customer: id });
                }}
                filter={customer}
              />
              <AutoInput
                form={this.props.form}
                value={this.state.address}
                attribute={"address"}
              />
              <AutoInput
                form={this.props.form}
                value={this.state.rfc}
                attribute={"rfc"}
              />
              <AutoInput
                form={this.props.form}
                model={"instructionletter"}
                attribute={"email"}
              />
              <AutoInput
                form={this.props.form}
                model={"instructionletter"}
                attribute={"phone_number"}
              />
            </Form>
          </TabPane>
          <TabPane tab="Tipo de Servicio" key="type_service">
            <Form>
              <AutoInput
                form={this.props.form}
                model={"instructionletter"}
                id={this.props.id}
                attribute={"type_service"}
                delayTime={100}
              />
              <AutoInput
                form={this.props.form}
                model={"instructionletter"}
                attribute={"reference"}
              />
              <AutoInput
                form={this.props.form}
                model={"instructionletter"}
                attribute={"incoterm"}
                type={'model'}
                items={['EXW', 'FCA', 'CPT', 'CIP', 'DAP', 'DPU', 'DDP', 'CFR', 'FOB', 'FAS', 'CIF']}
              />
              <AutoInput
                form={this.props.form}
                model={"instructionletter"}
                attribute={"type_equipment"}
              />
              <AutoInput
                form={this.props.form}
                model={"instructionletter"}
                attribute={"pickup_address"}
              />
              <AutoInput
                form={this.props.form}
                model={"instructionletter"}
                attribute={"pol"}
              />
              <AutoInput
                form={this.props.form}
                model={"instructionletter"}
                attribute={"pod"}
              />
              <AutoInput
                form={this.props.form}
                model={"instructionletter"}
                attribute={"delivery_address"}
              />
            </Form>
          </TabPane>
          <TabPane tab="Mercancia" key="merchandise">
            <Form>
              <AutoInput
                form={this.props.form}
                model={"instructionletter"}
                attribute={"description"}
              />
              <AutoInput
                form={this.props.form}
                model={"instructionletter"}
                attribute={"tariff"}
              />
              <AutoInput
                form={this.props.form}
                model={"instructionletter"}
                attribute={"type_packaging"}
              />
              <AutoInput
                form={this.props.form}
                model={"instructionletter"}
                attribute={"volume"}
              />
              <AutoInput
                form={this.props.form}
                model={"instructionletter"}
                attribute={"weight"}
              />
              <AutoInput
                form={this.props.form}
                model={"instructionletter"}
                attribute={"cbm"}
              />
              <AutoInput
                form={this.props.form}
                model={"instructionletter"}
                attribute={"lenght"}
              />
              <AutoInput
                form={this.props.form}
                model={"instructionletter"}
                attribute={"width"}
              />
              <AutoInput
                form={this.props.form}
                model={"instructionletter"}
                attribute={"height"}
              />
              <AutoInput
                form={this.props.form}
                model={"instructionletter"}
                attribute={"quantity"}
              />
            </Form>
          </TabPane>
          <TabPane tab="Instrucciones Especiales" key="special_info">
            <Form>
              <AutoInput
                form={this.props.form}
                model={"instructionletter"}
                attribute={"special_description"}
                placeholder="Description"
              />
            </Form>
          </TabPane>
        </Tabs>
      </div>
    );
  }
}

export default withValues(InstructionLetterCreate);



// WEBPACK FOOTER //
// ./src/forms/InstructionLetterCreate.js